import { registerQuery } from 'data-fetching-client';
import { fetchChannelInstance, fetchChannelInstances } from '../clients/channel-instance.api';
export const fetchChannelInstanceQuery = registerQuery({
  args: ['channelInstanceId'],
  fetcher: fetchChannelInstance,
  fieldName: 'channelInstance'
});
export const fetchChannelInstancesQuery = registerQuery({
  args: ['channelInstanceIds'],
  fetcher: fetchChannelInstances,
  fieldName: 'channelInstances'
});